export var IdAppsflyerEvents;
(function (IdAppsflyerEvents) {
    IdAppsflyerEvents["LEVEL_X_ACHIEVED"] = "af_level{0}_achieved";
    IdAppsflyerEvents["LEVEL_ACHIEVED"] = "af_level_achieved";
    IdAppsflyerEvents["CURRENT_LEVEL"] = "af_current_level";
    IdAppsflyerEvents["COOP_JOINED"] = "af_joined_alliance";
    IdAppsflyerEvents["FIRST_PURCHASE"] = "af_first_ingame_purchase";
    IdAppsflyerEvents["TUTORIAL_COMPLETION"] = "af_tutorial_completion";
    IdAppsflyerEvents["PURCHASE"] = "af_purchase";
    IdAppsflyerEvents["PU_CLUSTER_PURCHASED"] = "PU_Cluster_{0}";
})(IdAppsflyerEvents || (IdAppsflyerEvents = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/IdAppsflyerEvents.ts
// module id = 341
// module chunks = 3